import React, { Component } from "react";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import CustomMarker from "../helpers/CustomMarker";
import { markerCluster } from "../helpers/markerCluster";
import mapstyles from "../theme/map.json";

import {
  searchCrimesByLocation,
  searchAvailability,
  showSearch,
  changeDate,
  selectIncidents
} from "../actions/search";

import { Card, CardContainer } from "../components/Card";
import SearchButton from "../components/SearchButton";
import Incident from "../components/Incident";
import Loader from "../components/Loader";
import FadeIn from "../animations/FadeIn";

import searchIcon from "../media/search.png";

const MapCanvasWrapper = styled.div`
  width: 100%;
  height: 50vh;
  @media screen and (min-width: 768px) {
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;
    width: 65vw;
    transition: filter 1s ease-in-out;
    filter: ${({ loading }) => (loading ? "blur(5px);" : "blur(0px)")};
  }
`;

const MapCanvas = styled.div`
  width: 100%;
  height: 100%;
`;

const Container = styled.div`
  width: 100vw;
  height: 100%;
`;

const LocationContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 2;
  width: 100%;
  height: 50px;
`;

const LocationName = styled.div`
  background: white;
  width: 100%;
  padding-left: 20px;
  font-size: 16px;
  line-height: 48px;
`;

const SearchContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  padding: 20px;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  form {
    height: 62px;
    display: flex;
    flex-direction: row;
    width: 100%;
    border: 2px solid ${({ theme }) => theme.colors.main};
    border-radius: 50px;
    overflow: hidden;
  }
  input {
    background: transparent;
    border: none;
    height: 60px;
    padding-left: 20px;
    width: 100%;
    outline: none;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.main};
    outline: none;
    font-size: 16px;
    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 30px white inset;
    }
  }
  select {
    -webkit-appearance: none;
    border: none;
    background: transparent;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.main};
    margin-right: 10px;
    outline: none;
  }
  ${SearchButton} {
    margin-top: 4px;
    margin-right: 6px;
  }
  @media screen and (min-width: 768px) {
    height: 100vh;
    width: 35vw;
    transition: filter 1s ease-in-out;
    filter: ${({ loading }) => (loading ? "blur(5px);" : "blur(0px)")};
  }
`;

const Street = styled.div`
  padding: 10px 0px;
  display: inline-block;
  span {
    background-color: #f9681d;
    color: white;
    padding: 2px 5px;
    border-radius: 4px;
    margin: 0;
  }
  p {
    display: inline-block;
  }
  p::first-letter {
    text-transform: lowercase;
  }
`;

const LocationPanel = ({ location }) =>
  <LocationContainer>
    <LocationName>
      {location}
    </LocationName>
  </LocationContainer>;

class MapContainer extends Component {
  componentDidMount() {
    this.props.searchAvailability();
    this.markers = [];
    this.boundary = {};
    this.heatmap = false;

    if (this.props.search.crimes.length < 1) {
      this.getDataByUrl(this.props.match.params);
    }

    this.map = new window.google.maps.Map(this.mapNode, {
      zoom: 14,
      center: {
        lat: parseFloat(this.props.match.params.lat),
        lng: parseFloat(this.props.match.params.lng)
      },
      disableDefaultUI: true,
      styles: mapstyles,
      backgroundColor: "#212121"
    });
    this.map.addListener("zoom_changed", () => {
      this.renderMarkers(this.props.search.crimes, this.map.zoom);
      if (this.map.zoom > 16) {
        this.heatmap.setMap(null);
      } else {
        this.setHeatMapOptions();
      }
    });
    window.onresize = () => {
      window.google.maps.event.trigger(this.map, "resize");
      this.map.setCenter({
        lat: parseFloat(this.props.match.params.lat),
        lng: parseFloat(this.props.match.params.lng)
      });
    };
    this.renderMarkers(this.props.search.crimes);
  }

  getDataByUrl(params) {
    this.props.searchCrimesByLocation({
      location: {
        lat: params.lat,
        lng: params.lng
      },
      date: params.date
    });
  }

  setNewMapCenter(lat, lng) {
    const center = new window.google.maps.LatLng(lat, lng);
    this.map.panTo(center);
  }

  componentWillReceiveProps(nextProps) {
    const oldProps = this.props.search;
    const newProps = nextProps.search;
    const oldUrl = this.props.match.url;
    const newUrl = nextProps.match.url;
    const { lat, lng, date } = newProps.currentSearch;

    if (oldProps.crimes.length < 1) {
      this.renderMarkers(newProps.crimes);
      return;
    }

    if (
      oldProps.isSearching &&
      newProps.searchComplete &&
      oldProps.crimes[0].id !== newProps.crimes[0].id
    ) {
      this.renderMarkers(newProps.crimes, this.map.zoom);
      this.setNewMapCenter(lat, lng);
      this.props.push(`/map/${lat}/${lng}/${date}`);
      return;
    }

    if (newUrl !== oldUrl && oldProps.crimes.length < 1) {
      this.getDataByUrl(nextProps.match.params);
    }
  }

  renderMarkers(crimes, zoom) {
    const clusteredCrimes = markerCluster(crimes, zoom);
    this.markers.forEach(marker => {
      marker.setMap(null);
    });
    Object.keys(clusteredCrimes).forEach(crime => {
      const loc = crime.split(",");
      this.markers.push(
        new CustomMarker(
          new window.google.maps.LatLng(parseFloat(loc[0]), parseFloat(loc[1])),
          this.map,
          {},
          clusteredCrimes[crime].length,
          () => this.props.selectIncidents(clusteredCrimes[crime])
        )
      );
    });
    if (this.props.search.boundary.length > 1) {
      this.renderBoundary(this.props.search.boundary);
      this.renderHeatmap(crimes);
    }
  }

  renderBoundary(boundary) {
    if (this.boundary.visible) {
      this.boundary.setMap(null);
    }
    const normalisedBoundary = boundary.map(({ latitude, longitude }) => {
      return { lat: parseFloat(latitude, 10), lng: parseFloat(longitude, 10) };
    });
    this.boundary = new window.google.maps.Polygon({
      paths: normalisedBoundary,
      strokeColor: "hsla(221, 95%, 59%, 1)",
      strokeOpacity: 0.3,
      strokeWeight: 5,
      fillColor: "hsla(258, 95%, 59%, 1)",
      fillOpacity: 0.01
    });

    this.boundary.setMap(this.map);
  }

  renderHeatmap(crimes) {
    if (this.heatmap) {
      this.heatmap.setMap(null);
    }

    this.heatmap = new window.google.maps.visualization.HeatmapLayer({
      data: crimes.map(
        ({ location }) =>
          new window.google.maps.LatLng(
            parseFloat(location.latitude, 10),
            parseFloat(location.longitude, 10)
          )
      )
    });

    this.setHeatMapOptions();

    this.heatmap.setMap(this.map);
  }

  setHeatMapOptions() {
    const colors = [
      "rgba(0, 255, 255, 0)",
      "rgba(0, 255, 255, 1)",
      "rgba(0, 191, 255, 1)",
      "rgba(0, 127, 255, 1)",
      "rgba(0, 63, 255, 1)",
      "rgba(0, 0, 255, 1)",
      "rgba(0, 0, 223, 1)",
      "rgba(0, 0, 191, 1)",
      "rgba(0, 0, 159, 1)",
      "rgba(0, 0, 127, 1)",
      "rgba(63, 0, 91, 1)",
      "rgba(127, 0, 63, 1)",
      "rgba(191, 0, 31, 1)",
      "rgba(255, 0, 0, 1)"
    ];
    this.heatmap.setOptions({
      dissipating: true,
      maxIntensity: 10,
      radius: 30,
      opacity: 0.2,
      gradient: colors
    });
  }

  searchHandler(e) {
    e.preventDefault();
    this.props.searchCrimesByLocation({
      date: this.props.search.currentSearch.date,
      address: e.target.address.value
    });
  }

  renderCrimesByCategory(crimesByCategory, categories) {
    return crimesByCategory.map((cat, i) =>
      <p key={i}>
        <span>{cat.value}</span> {categories[cat.name]}
      </p>
    );
  }

  renderSelectedIncidents(incidents, categories) {
    const sortedByStreet = incidents.reduce((prev, current) => {
      const { id, name } = current.location.street;
      if (prev[id]) {
        prev[id].crimes = [...prev[id].crimes, current];
        prev[id].categories = {
          ...prev[id].categories,
          [current.category]: prev[id].categories[current.category]
            ? prev[id].categories[current.category] + 1
            : 1
        };
        return prev;
      } else {
        prev[id] = {
          name,
          crimes: [current],
          categories: {
            [current.category]: 1
          }
        };
        return prev;
      }
    }, {});

    const sortedByCrimeFrequency = Object.keys(sortedByStreet)
      .map(id => {
        return {
          ...sortedByStreet[id],
          categories: Object.keys(sortedByStreet[id].categories)
            .map(cat => {
              return {
                category: categories[cat],
                total: sortedByStreet[id].categories[cat]
              };
            })
            .sort((a, b) => b.total - a.total)
        };
      })
      .sort((a, b) => b.crimes.length - a.crimes.length);
    return sortedByCrimeFrequency.map(street =>
      <div key={street.crimes[0].location.street.id}>
        <Street>
          <span>{street.crimes.length}</span> crime{street.crimes.length > 1 && "s"}{" "}
          <p>{street.name}</p>
        </Street>
        {street.categories.map(cat =>
          <Incident key={cat.category}>
            {cat.total} {cat.category}
          </Incident>
        )}
      </div>
    );
  }

  renderCard(isSearching) {
    const { formattedAddress, currentDate } = this.props.search.currentSearch;
    const categories = this.props.search.categories[currentDate];
    const { crimesByCategory, selectedIncidents } = this.props.search;
    return (
      <CardContainer key="card" loading={isSearching}>
        <Card>
          {selectedIncidents.length > 0
            ? this.renderSelectedIncidents(selectedIncidents, categories)
            : this.renderCrimesByCategory(crimesByCategory, categories)}
        </Card>
        <LocationPanel location={formattedAddress} />
        <SearchButton onClick={() => this.props.showSearch()}>
          <img alt="Search by Address" src={searchIcon} />
        </SearchButton>
      </CardContainer>
    );
  }

  renderSearch(isSearching) {
    return (
      <SearchContainer key="search" loading={isSearching}>
        <form onSubmit={e => this.searchHandler(e)}>
          <input
            autoFocus
            placeholder="Enter an address or post code"
            name="address"
            type="text"
          />
          <select onChange={e => this.props.changeDate(e.target.value)}>
            {this.props.search.availability.map(d =>
              <option key={d.date} value={d.date}>
                {new Date(d.date).toLocaleString("en-GB", {
                  month: "short",
                  year: "numeric"
                })}
              </option>
            )}
          </select>
          <SearchButton>
            <img alt="Search by Address" src={searchIcon} />
          </SearchButton>
        </form>
      </SearchContainer>
    );
  }

  render() {
    const { showSearch, isSearching } = this.props.search;
    return (
      <Container>
        <FadeIn>
          {isSearching && <Loader key="loader" />}
        </FadeIn>
        <FadeIn>
          {showSearch && this.renderSearch(isSearching)}
        </FadeIn>
        {this.renderCard(isSearching)}
        <MapCanvasWrapper loading={isSearching}>
          <MapCanvas innerRef={node => (this.mapNode = node)} />
        </MapCanvasWrapper>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  search: state.search
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    Object.assign(
      {},
      {
        showSearch,
        searchCrimesByLocation,
        searchAvailability,
        push,
        changeDate,
        selectIncidents
      }
    ),
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);



// WEBPACK FOOTER //
// ./src/containers/MapContainer.js